import {
    CallClientState,
    CallState,
    ChatClientState,
    StatefulCallClient,
    StatefulChatClient,
} from '@azure/communication-react';
import { Call, EnvironmentInfo } from '@azure/communication-calling';
import { StateCreator } from 'zustand';
import { PcpLiveLessonState } from '../pcpLiveLessonStore.interface';
import { getCallCompositePage } from '../../utils/pageUtils';
import { PcpCallCompositePage } from '../../interfaces';


const unsupportedBrowserVersionsAllowed = true; // allow unsupported browser versions for since feature is still in beta


export interface StatefulClientsState {
    // callClient: StatefulCallClient;
    // chatClient: StatefulChatClient;

    callClientState: CallClientState;
    chatClientState: ChatClientState;

    callState: CallState | undefined;
    callCompositePage: PcpCallCompositePage;

    /**
     * Cached call object.
     * NOTE: do not cache the CallId because it can change during the call.
     * Always use the call object to access the call ID.
     */
    call: Call | undefined;

    setCallClientState: (state: CallClientState) => void;
    setChatClientState: (state: ChatClientState) => void;

    setCall: (call: Call | undefined) => void;

    isLocalPreviewMicrophoneEnabled: boolean;
    toggleLocalPreviewMicrophone: () => void;
    // page: CallCompositePage;
}

export const createStatefulClientsSliceWithProps = (
    callClient: StatefulCallClient,
    chatClient: StatefulChatClient
): StateCreator<
    PcpLiveLessonState,
    [["zustand/immer", never]],
    [],
    StatefulClientsState
> => (set, get) => ({
    // callClient: undefined,
    // chatClient: undefined,

    callClientState: callClient.getState(),
    chatClientState: chatClient.getState(),

    call: undefined,
    callId: undefined,

    callState: undefined,
    callCompositePage: 'configuration',

    isLocalPreviewMicrophoneEnabled: false,

    setCallClientState: (callClientState) => {

        const call = get().call;
        const callId = call?.id;
        const nextCallState = callId ? callClientState.calls[callId] : undefined;


        const environmentInfo = get().callClientState.environmentInfo as EnvironmentInfo;
        const latestEndedCall = callClientState.callsEnded ? findLatestEndedCall(callClientState.callsEnded) : undefined;
        const acsPage = getCallCompositePage(
            nextCallState,
            latestEndedCall,
            false, // isReturningFromBreakoutRoom
            {
                environmentInfo,
                unsupportedBrowserVersionOptedIn: unsupportedBrowserVersionsAllowed,
            }
        );

        set({
            callClientState: callClientState,
            callState: nextCallState,
            callCompositePage: acsPage,
        });
    },

    setChatClientState: (state) => {
        // Store the ACS state ref as-is. ACS returns a fresh ref only on a real change, so the
        // per-event { ...state } clone was pure waste on the hottest path (every chat message).
        set({ chatClientState: state });
    },

    setCall: (call: Call | undefined) => {
        set({ call });
        // console.log("Call updated:", call);
    },

    toggleLocalPreviewMicrophone: () => {
        set(state => {
            state.isLocalPreviewMicrophoneEnabled = !state.isLocalPreviewMicrophoneEnabled;
        });
    },
});


const findLatestEndedCall = (calls: { [key: string]: CallState }): CallState | undefined => {
    const callStates = Object.values(calls);
    if (callStates.length === 0) {
        return undefined;
    }
    let latestCall = callStates[0];
    for (const call of callStates.slice(1)) {
        if ((call.endTime?.getTime() ?? 0) > (latestCall?.endTime?.getTime() ?? 0)) {
            latestCall = call;
        }
    }
    return latestCall;
};
